import { PricelistDto } from '../../../common/PricePrgClient';
import {
    notifyPricelistCreated,
    notifyPricelistDeleted,
    notifyPricelistUpdated
} from '../../../common/signalr/signalrActions';
import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { fetchPricelistsForCustomer } from '../../customer/redux/customerSlices';
import { pricePrgError } from '../../ui/redux/uiSlices';
import {
    closeCreatePricelistDialog,
    connectPricelistCustomers,
    createPricelist,
    deletePricelist,
    fetchCustomersForPricelist,
    fetchPricelistPeriods,
    fetchPricelists,
    hideConnectPricelistDialog,
    pricelistsSelected,
    updatePricelist
} from './pricelistSlices';

const fetchPricelists$ = createEpicFromAsyncActionEmptyRequest(fetchPricelists, ({ pricelistClient }) =>
    pricelistClient.getAllPricelists()
);

const fetchPricelistPeriods$ = createEpicFromAsyncAction(
    fetchPricelistPeriods,
    (payload, { pricelistClient }) => pricelistClient.getPricelistsPeriodsForPricelists(payload)
);

const updatePricelist$ = createEpicFromAsyncAction(
    updatePricelist,
    (payload, { pricelistClient }) => pricelistClient.updatePricelist(payload.pricelistId, payload.dto),
    req => notifyPricelistUpdated(req.pricelistId)
);

const createPricelist$ = createEpicFromAsyncAction(
    createPricelist,
    (payload, { pricelistClient }) =>
        pricelistClient.createPricelist(payload).then(
            plId =>
                ({
                    isBasePricelist: false,
                    pricelistId: plId,
                    pricelistRef: payload.ref,
                    name: payload.name,
                    parentPricelistId: payload.parentPricelistId,
                    currency: payload.currency,
                    pricelistPeriodDayLength: 365,
                    applyCommentsToChildren: false,
                    emptyPricelistOnCreate: false,
                    hasWeekdayRestrictions: false,
                    allowedWeekdays: [],
                    forbidCalculationBypass: false,
                    isReadonly: false,
                    ignoreAgreementPricesOnPricelistMail: false,
                    useDefaultCurrencyConversion: false,
                    mainCurrencyPricelistId: payload.mainCurrencyPricelistId
                } as PricelistDto)
        ),
    (req, resp) => [
        notifyPricelistCreated(resp),
        pricelistsSelected([resp.pricelistId]),
        closeCreatePricelistDialog()
    ],
    (_, err) => pricePrgError(err)
);

const deletePricelist$ = createEpicFromAsyncAction(
    deletePricelist,
    (payload, { pricelistClient }) => pricelistClient.deletePricelist(payload).then(() => payload),
    req => notifyPricelistDeleted(req)
);

const fetchCustomersForPricelist$ = createEpicFromAsyncAction(
    fetchCustomersForPricelist,
    (payload, { customerClient }) => customerClient.getCustomerIdsForPricelist(payload)
);

const connectPricelistCustomers$ = createEpicFromAsyncAction(
    connectPricelistCustomers,
    (payload, { pricelistCustomerClient }) =>
        pricelistCustomerClient.create(payload.customerId, payload.pricelistId).then(() => payload),
    req => [
        fetchCustomersForPricelist.request(req.pricelistId),
        fetchPricelistsForCustomer.request(req.customerId),
        hideConnectPricelistDialog()
    ]
);

export default [
    fetchPricelistPeriods$,
    fetchPricelists$,
    updatePricelist$,
    createPricelist$,
    deletePricelist$,
    fetchCustomersForPricelist$,
    connectPricelistCustomers$
];
